import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// User List
export const userManagementListApi = async (data) => {
  const endPoint = `/admin/users?${new URLSearchParams(data)}`;
  return await axios.get(endPoint, setJwtToken());
};

// ----user detail
export const userDetailApi = async (id) => {
  const endPoint = `/admin/users/details/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

// ----DO user Block and unblock
export const userBlockAndUnblockApi = async ({ id, status }) => {
  const endPoint = `/admin/users/status/${id}`;
  return await axios.patch(endPoint, { status }, setJwtToken());
};

// ----DO user Block and unblock
export const editUserApi = async (id, data) => {
  const endPoint = `/admin/users/${id}`;
  return await axios.put(endPoint, data, setJwtToken());
};
// -----------download-File-Api----------------
export const downloadFileApi = async (data) => {
  const endPoint = `/admin/users/export?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, { ...setJwtToken(), responseType: 'blob', });
};
// -----------card-list-API---------------
export const cartListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/cart?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// -----------add-To-Cart-Quantity-Api-------------------
export const addToCartQuantityApi = async (data) => {
  const endPoint = `/admin/users/cart/update/quantity`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------Medicine-list-API---------------
export const medicineListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/product?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// -----------add-to-cart-API---------------
export const addToCartApi = async (data) => {
  const endPoint = `/admin/users/cart`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------add-Refill-Product-API---------------
export const addRefillProductApi = async (data) => {
  const endPoint = `/admin/users/refillorder`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------update-Refill-Product-API---------------
export const updateRefillProductApi = async (data) => {
  const endPoint = `/admin/users/refillorder/update`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------refill-list-API---------------
export const refillListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/refillorder?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// -----------refill-address-list-API---------------
export const refillAddressListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/address?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// -----------coin-list-API---------------
export const coinListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/reward?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// -----------order-history-list-API---------------
export const orderHistoryListApi = async (id, data) => {
  const endPoint = `/admin/users/${id}/order?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// -----------change-Status-Refill-API---------------
export const changeStatusRefillApi = async (data) => {
  const endPoint = `/admin/users/refillorder/update`;
  return await axios.post(endPoint, data, setJwtToken());
};

export const confirmOrder = async (data) => {
  const endPoint = `/admin/users/confirm-cart`;
  return await axios.post(endPoint, data, setJwtToken());
};

